import { useMemo, useState } from 'react';

const dataFormatter = (data, maxDepth = null, depth = 0, parent = null) => {
  const formattedData = [];

  data.forEach((datum) => {
    const isLeaf = !datum.children || datum.children.length === 0;
    const formattedDatum = {
      depth,
      parents: parent === null ? [] : [...parent.parents, parent.id],
      isLeaf,
      ...datum,
      children: [],
      parent,
    };

    if (maxDepth !== null && depth >= maxDepth - 1) {
      formattedDatum.isLeaf = true;
      formattedDatum.children = [];
    } else if (!isLeaf) {
      const children = dataFormatter(
        datum.children,
        maxDepth,
        depth + 1,
        formattedDatum,
      );

      if (children.length === 1) {
        formattedDatum.isLeaf = true;
        formattedDatum.children = [];
        formattedDatum.path = children[0].path;
      } else {
        formattedDatum.children = children;
      }
    }

    formattedData.push(formattedDatum);
  });

  return formattedData;
};

const useFormattedNodesTree = (
  data,
  isSuccess,
  onSelect = () => null,
  maxDepth = null,
) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const formattedData = useMemo(() => {
    if (isSuccess) {
      return dataFormatter(data, maxDepth);
    }

    return [];
  }, [data, isSuccess, maxDepth]);

  const handleSelection = (item) => {
    if (item && item.isLeaf) {
      setSelectedItem(null);
      onSelect();
    } else if (item && selectedItem && item.id === selectedItem.id) {
      setSelectedItem(item.parent);
    } else {
      setSelectedItem(item);
    }
  };

  return {
    formattedData,
    selectedItem,
    handleSelection,
  };
};

export default useFormattedNodesTree;
